import { I18n } from '@calendly/i18n';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const formatsHintIsAdminIACss = "f5uaini";
const formatsHintIsPhoneCss = "fppudeb";
const formatsHintCss = "f197ikx8";
export const FormatsHint = forwardRef((props, ref) => {
  const {
    isAdminIA,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(formatsHintCss, {
    [formatsHintIsAdminIACss]: isAdminIA,
    [formatsHintIsPhoneCss]: isPhone
  }, props.className)}>
      {I18n.t('publisher.action.image_formats')}
    </Component>;
});

require("./formats_hint.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./formats_hint.js");